import request from '@/utils/request'


export function homeResult(query) {
  return request({
    url: '/biz/admin/statistics/home/home',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function homePlatResult(query) {
  return request({
    url: '/biz/admin/statistics/home/home/plat',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


export function homeAllResult(query) {
  return request({
    url: '/biz/admin/statistics/home/home/all',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

/*广告*/
export function advertResult(query) {
  return request({
    url: '/biz/admin/statistics/home/advert',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

/*商品分享*/
export function goodsResult(query) {
  return request({
    url: '/biz/admin/statistics/home/goods',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


export function dataOverview(query) {
  return request({
    url: '/biz/admin/statistics/data/overview',
    method: 'get',
    params: query
  })
}
